// The WellSky warnings this write hit, for the coordinator to wave through.
import { type ReactNode, useEffect, useState } from 'react';

import { Checkbox } from '@apps/web/components/ui/checkbox';
import { Label } from '@apps/web/components/ui/label';
import { type EhrOverrideEditor } from '@apps/web/features/phoebe_chat_v3/model/shift_write_card';

export type EhrOverrideAnswers = Readonly<Record<string, boolean>>;

export function EhrOverrideField({
    editor,
    disabled,
    onChange,
}: Readonly<{
    editor: EhrOverrideEditor;
    disabled: boolean;
    onChange: (answers: EhrOverrideAnswers) => void;
}>): ReactNode {
    const [allowed, setAllowed] = useState<Record<string, boolean>>({});

    useEffect(() => {
        onChange(allowed);
    }, [allowed, onChange]);

    return (
        <div className="mt-2 flex flex-col gap-2">
            <p className="text-muted-foreground text-v3-chat-meta m-0">
                {editor.target} will not save this until these are allowed.
            </p>
            {editor.warnings.map((warning) => (
                <Label
                    key={warning.key}
                    htmlFor={`v3-override-${warning.key}`}
                    className="text-v3-chat-meta flex items-start gap-2 font-normal"
                >
                    <Checkbox
                        id={`v3-override-${warning.key}`}
                        checked={allowed[warning.key] === true}
                        disabled={disabled}
                        onCheckedChange={(checked) =>
                            setAllowed((current) => ({
                                ...current,
                                [warning.key]: checked === true,
                            }))
                        }
                    />
                    <span className="min-w-0">
                        {warning.label}
                        <span className="text-muted-foreground block">
                            {warning.consequence}
                        </span>
                    </span>
                </Label>
            ))}
        </div>
    );
}
